import { render, staticRenderFns } from "./PhotoFaceLowQualityModal.vue?vue&type=template&id=0776060d"
import script from "./PhotoFaceLowQualityModal.vue?vue&type=script&lang=js"
export * from "./PhotoFaceLowQualityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports